import { render, staticRenderFns } from "./InventoryFilters.vue?vue&type=template&id=134c1345&"
import script from "./InventoryFilters.vue?vue&type=script&lang=js&"
export * from "./InventoryFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports